const PRICE_DISCLOSURE_TEXT =
  'Prices are shown in US dollars and are per person inclusive of taxes and fees with the exception of '

const BAGGAGE_FEES_TEXT = 'baggage fees'

export { BAGGAGE_FEES_TEXT, PRICE_DISCLOSURE_TEXT }
